import type { ReactNode } from 'react';
import type { Tone } from './tone';

const TONES: Record<Tone, string> = {
    neutral: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
    brand: 'bg-brand-50 text-brand-800 dark:bg-brand-950 dark:text-brand-300',
    positive: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
    warning: 'bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-300',
    critical: 'bg-rose-50 text-rose-800 dark:bg-rose-950 dark:text-rose-300'
};

/**
 * A word about a record's state, next to the record.
 *
 * **The dot is not decoration.** A badge that carries meaning in its colour alone is unreadable to
 * roughly one man in twelve, and these are the words a customer scans a list by — so the state is
 * always spelled out and the colour only agrees with it. The dot is there to make the word findable
 * at a glance, not to replace it.
 */
export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
    return (
        <span
            className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${TONES[tone]}`}
        >
            <span className="size-1.5 rounded-full bg-current opacity-70" aria-hidden="true" />
            {children}
        </span>
    );
}
